import { ArrowLeft, ChevronRight } from "lucide-react"
import { Fragment } from "react"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"

type Props = {
  labels: string[]
  onNavigate: (index: number) => void
  onBack: () => void
}

export const Breadcrumb = ({ labels, onNavigate, onBack }: Props) => (
  <div className="flex items-center gap-1 text-xs text-muted-foreground">
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          aria-label="Back"
          className="shrink-0 cursor-pointer rounded p-1 hover:bg-muted hover:text-foreground disabled:cursor-default disabled:opacity-40"
          onClick={onBack}
          disabled={labels.length === 0}
        >
          <ArrowLeft className="size-4" />
        </button>
      </TooltipTrigger>
      <TooltipContent side="top">Back</TooltipContent>
    </Tooltip>
    <div className="flex min-w-0 items-center gap-1 overflow-hidden">
      {labels.map((label, i) => (
        <Fragment key={i}>
          {i > 0 ? <ChevronRight className="size-3 shrink-0" /> : null}
          <button
            className="max-w-[10rem] cursor-pointer truncate hover:text-foreground hover:underline"
            title={label}
            onClick={() => onNavigate(i)}
          >
            {label}
          </button>
        </Fragment>
      ))}
    </div>
  </div>
)
